import http from '@utils/http';

export const getSchedules = (params = {}) =>
    http.get('/hr/schedules', { params }).then((res) => {
        const payload = res.data ?? {};
        let list = payload.data ?? payload;
        if (list && typeof list === 'object' && !Array.isArray(list) && Array.isArray(list.data)) {
            list = list.data;
        }
        const data = Array.isArray(list) ? list : [];
        return {
            data,
            total: payload.total ?? data.length,
            page: payload.page ?? 1,
            limit: payload.limit ?? 10,
            totalPages: payload.totalPages ?? 1,
        };
    });

export const getScheduleById = (id) => http.get(`/hr/schedules/${id}`).then((res) => res.data?.data ?? res.data);

export const createSchedule = (data) => http.post('/hr/schedules', data).then((res) => res.data?.data ?? res.data);

export const updateSchedule = (id, data) => http.put(`/hr/schedules/${id}`, data).then((res) => res.data?.data ?? res.data);

export const deleteSchedule = (id) => http.delete(`/hr/schedules/${id}`).then((res) => res.data?.data ?? res.data);

export const assignUsersToSchedule = (id, userIds) =>
    http.post(`/hr/schedules/${id}/users`, { userIds }).then((res) => res.data?.data ?? res.data);
